import { z } from 'zod'

/** Completion Certificates for a class's public id, from Class Details' sidebar. */
export const classCertificatesRoute = '/credentials/classes/:classId/certificates'

export function classCertificatesPath(classId: string): string {
  return `/credentials/classes/${encodeURIComponent(classId)}/certificates`
}

/** The permission printing other people's certificates needs; an instructor holds it for their own classes. */
export const printCertificatesPermission = 'credentials.certificates.read'

/** What printing a class's certificates offers. */
export function classPrintingApi(classId: string): string {
  return `/credentials/v1/classes/${encodeURIComponent(classId)}/certificate-printing`
}

export type CertificateFormat = 'pdf' | 'docx'

/** The zip of the class's certificates, from one template, in one format. */
export function classCertificatesApi(classId: string, templateId: string, format: CertificateFormat): string {
  const query = new URLSearchParams({ templateId, format })
  return `/credentials/v1/classes/${encodeURIComponent(classId)}/certificates?${query.toString()}`
}

const printingSchema = z.object({
  classId: z.string(),
  className: z.string(),
  certificateTemplates: z.array(z.object({ id: z.string(), name: z.string() })),
  mayPrintWord: z.boolean(),
  students: z.array(z.object({ userId: z.string(), name: z.string() })),
})

/** The certificates a class gives that can print, whether the viewer may print Word copies, and the students who get one. */
export type ClassPrinting = z.infer<typeof printingSchema>

export function parseClassPrinting(body: unknown): ClassPrinting {
  return printingSchema.parse(body)
}
